module.exports = __webpack_public_path__ + "media/images/talent/case04-illust-9d90f07c83bee4db892c560aa7e8605b.png";